// src/products.js
const products = [
  {
    id: "p1",
    name: "Velas ritualizadas",
    price: 0, // 25,00 €
    image: "/images/velas.png",
    description: "Velas ritualizadas para el día 11 de cada mes. «Que no falte nunca el dinero.» Están disponibles paquetes de 6 y 12 velas.",
    category: "Rituales",
    slug: "velas-ritualizadas"
  },
  {
    id: "p2",
    name: "Moneda Talisman",
    price: 0, // 15,00 €
    image: "/images/monedaTalisman.png",
    description: "Talismán único y personalizado. «El hijo hecho de hombre sin que conozca mujer y de mujer sin que toque el hombre… El talismán Sagrado».",
    category: "Talismanes",
    slug: "moneda-talisman"
  },
  {
    id: "p3",
    name: "Pulsera Ritual",
    price: 0, // 40,00 €
    image: "/images/pulseraTalisman.png",
    description: "«El poder del 28 sobre tu vida» Talismán que activa tu poder mental, protege contra el mal, brujería y todo lo que viene de la oscuridad. Protege tu vida con Los 28…",
    category: "Talismanes",
    slug: "pulsera-talisman"
  },
  {
    id: "p4",
    name: "Limpieza espiritual",
    price: 0, // 35,00 €
    image: "/images/limpiezaEspiritual.jpg",
    description: "Sesión de limpieza energética para equilibrar tu aura.",
    category: "Rituales",
    slug: "limpieza-espiritual"
  },
  {
    id: "p5",
    name: "Libro: Un suspiro en la eternidad",
    price: 1500, // 18,00 €
    priceId: "price_1SE4XuBeI4d7ilSKuNm6Vee2", // ID generado en Stripe Dashboard
    image: "/images/unSuspiro.jpg",
    description: "Cuando decidió hacer esta antología, con la cual a través de sus escritos puede recordar cómo se sentía cuando los redactó, sus pensamientos, sus emociones expresadas con sus palabras, sus sueños traducidos en el lenguaje universal del pensamiento, no puede evitar pensar en la palabra que da significado a este paso del tiempo: «Evolución». Desde siempre la ha gustado esa palabra y su significado. Evolucionar no es un obligado sinónimo de cambio, aunque en ocasionesvaya asociado a ello. El que más se ajusta a su propia definición de evolucionar es la adaptación. Una evolución implica que un ente se adapte a las circunstancias que le rodean en cada ámbito de su existencia, la naturaleza o la esencia, el alma, son inmutables, es la más pura identidad de cada ente, de cada persona, cuando se materializan en lo mundano aparece otra esencia otorgada por la razón o el pensamiento: el ego.Acerca de la autora, Doina Ro: Doina Barbu, más conocida como Doina Ro, nace en Onesti hace cincuenta años, una bellapoblación situada en el centro de Rumanía, en el seno de una familia humilde con firmes principios morales y fue educada bajo el amparo del régimen comunista dentro de un principio de igualdad, donde los sentimientos o cualquier tipo de fe y todo aquello que superara la realidad física estaba prohibido por el Estado. Su infancia se vio marcada por la figura de su abuelo, del cual, según la autora, …ha sido la figura más significativa e influyente desde que nací y sigue marcando toda su trayectoria hasta el momento (pese a que murió cuando era una niña). Llegó a España buscando la libertad trasla revolución, que acabó con el régimen de Ceausescu, donde pudo ser lo que ella deseaba, una bruja del universo 28,hace 17 años, y comenzó a realizar humildes empleos hasta que le llegó la oportunidad de salir en un programa de televisión,y ha seguido en el mundo de la televisión gozando de una magnífica reputación en el mundo esotérico y actualmentenos presenta su segunda novela.»… El camino fluye y sigue adelante, escribo mis sueños, nuestras historias, y me preparo para ser libre de verdad y así poder amar y sentir",
    category: "Libros",
    slug: "un-suspiro",
    ISBN:9781798261330
  },
  {
    id: "p6",
    name: "Libro: Los estigmas de un alma: Antología II parte",
    price: 1500, // 22,00 €
    priceId: "price_1SE4bHBeI4d7ilSK8tFSGwow", // ID generado en Stripe Dashboard
    image: "/images/losEstigmas.jpg",
    description: "Esta antología, continuación de Un suspiro en la eternidad (2018), recoge pensamientos, sueños, sensaciones y vivencias de Doina Ro. Esta nueva obra mantiene la esencia del lenguaje universal inherente a las experiencias del ser humano respecto a sus sentimientos. La autora, a la que le gusta significar la importancia de la evolución en la vida del ser humano, nos adentra en un mundo de cambios y de percepciones que más tienen que ver con el alma que con el físico. Se trata de adaptarse a las circunstancias que van planteándose en la vida, siempre desde un punto de vista en el que el amor es parte primordial del proceso.",
    category: "Libros",
    slug: "los-estigmas",
    ISBN:9798401139344
  },
  {
    id: "p7",
    name: "Libro: Miles de años juntos, hoy más que nunca",
    price: 2200, // 27,00 €
    priceId: "price_1SE4UnBeI4d7ilSKlSl5OgGD",// precio para pruevbas "price_1SFBGsBeI4d7ilSK9uv1gEXw", // // ID generado en Stripe Dashboard
    image: "/images/milesDeAños.jpg",
    description: "Una novela acerca de la inmortalidad de los sentimientos y sobre todo la eternidad del amor, reencarnación, reconocimiento, renacimiento, y reparación de los errores del alma. Personajes que vuelven a encontrarse y a través del tiempo y de distintas vidas aprenden que la vida tan solo hay que vivirla?Una novela acerca de la inmortalidad de los sentimientos y sobre todo la eternidad del amor, reencarnación, reconocimiento, renacimiento, y reparación de los errores del alma. Personajes que vuelven a encontrarse y a través del tiempo y de distintas vidas aprenden que la vida tan solo hay que vivirla?",
    category: "Libros",
    slug: "miles-de-años",
    ISBN:9788417072230
  },
  {
    id: "p8",
    name: "Libro: El número de poder de tu alma",
    price: 2200, // 16,00 €
    priceId: "price_1SE4NfBeI4d7ilSK5oJTSj7J", // ID generado en Stripe Dashboard
    image: "/images/elNumeroBlanda.jpg",
    description: 'Querido lector y habitante de uno de estos universos, te pediré que recuerdes al leer este libro que Doina 28 no puede saber todo, porque es simplemente un alma que recordó, y que tú también lo harás. Y tú y todos, con vuestros recuerdos, conseguiréis que nunca pare la escritura de este libro, y con el paso del tiempo nadie ni nada podrá escribir su nal… Doina 28, un alma que descubrió que no existe el tiempo pero que sí existe la eternidad… Os amo. …Amar antes de nacer y echar.',
    category: "Libros",
    slug: "numero-del-poder",
    ISBN: 9788412866827
  },
  {
    id: "p9",
    name: "Libro: El número de poder de tu alma(Tapa Dura)",
    price: 2390, // 16,00 €
    priceId: "price_1SE4ROBeI4d7ilSKRvrYySRC", // ID generado en Stripe Dashboard
    image: "/images/elNumeroDura.jpg",
    description: 'Querido lector y habitante de uno de estosuniversos, te pediré que recuerdes al leer este libro que Doina 28 no puede saber todo, porque es simplemente un alma que recordó, y que tú también lo harás. Y tú y todos, con vuestros recuerdos, conseguiréis que nunca pare la escritura de este libro, y con el paso del tiempo nadie ni nada podrá escribir su nal… Doina 28, un alma que descubrió que no existe el tiempo pero que sí existe la eternidad… Os amo. …Amar antes de nacer y echar.',
    category: "Libros",
    slug: "numero-del-poder-dura",
    ISBN:9788409651771
  },
  {
    id: "p10",
    name: "Limpieza energética",
    price: 0,
    image: "/images/limpiezaEnergetica.jpg",
    description: "Limpieza energética «Sacar plomo de la mente, alma y cuerpo…» Se puede hacer una vez cada 6 meses",
    category: "Rituales",
    slug: "limpieza-energetica"
  },
  {
    id: "p11",
    name: "Contacto para cita previa",
    price: 0,
    image: "/images/citaPrevia.jpg",
    description: "Para solicitar cualquier cita, deberá contactar al número: 637 09 85 42",
    category: "Rituales",
    slug: "cita-previa"

  },
  {
    id:"p12",
    name:'"El ritual  del fin de años.." El pan de cada dia..."',
    price: 14400,
    priceId: "price_1SSvTsBeI4d7ilSKOUptgJhR",
    video: [
      "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/ritualFinDeAno.mp4",
      "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/ritualFinDeAno2.mp4"
    ],
    description: "Que nunca falte el dinero, la salud y buena suerte en todo el año 2026.",
    category: "Rituales",
    slug: "ritual-fin-de-año"
  },
  {
    id:"p13",
    name:'"El ritual 13 de febrero"',
    price: 0,
    video: [
      "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/ritual13Febreo.mp4",
      "https://doinaro28web.s3.eu-central-1.amazonaws.com/videos/ritual13Febreo2.mp4"
    ],
    description: "El ritual 13 de febreo que nunca te falte el dinero en tu monedero.Doina Ro28",
    category: "Rituales",
    slug: "ritual-13-febrero"
  }

];

export default products;